import React from 'react';

import TableHeader from './TableHeader';
import TableBody from './TableBody';

const Table = (props) => {
    return (
        <table className="table table-striped profiles-permission">
            <TableHeader productos={props.productos}
                categorias={props.categorias}
                programas={props.programas}
                filter={props.filter}
                selectProducto={props.selectProducto}
                selectCategoria={props.selectCategoria}
                selectPrograma={props.selectPrograma} />
            <TableBody perfiles={props.perfiles}
                funciones_tabla={props.funciones_tabla}
                filter={props.filter}
                deleteFuncion={props.deleteFuncion}
                addFuncion={props.addFuncion} />
        </table>
    );
}

export default Table;